<template>
  <div>
    <rt-section title="附件" class="detail-table" icon="rt-portal-SALESMANAGEMENT">
      <template slot="btn">
        <rt-button @click="downloadMuiltiple" v-if="dataList.length">批量下载</rt-button>
        <!-- <el-button @click="deleteFile" v-if="canDelete && dataList.length">删除</el-button> -->
        <rt-button @click="uploadFile" v-if="canUpload">上传</rt-button>
      </template>
      <!-- <el-progress :text-inside="true" :stroke-width="20" :percentage="process"></el-progress> -->
      <rt-table :sectionable="false" :showPagination="false" :need-fetch="false" :no-needfetch-data="dataList"
        :data="dataList" ref="gridTable" v-loading="loading" :header-cell-style="{ background: '#F0F3F7' }" 
        :row-class-name="tabRowClassName" @selection-change="handleSelectionChange">
        <rt-table-column type="selection" width="80%"></rt-table-column>
        <rt-table-column label="名称" prop="filename"></rt-table-column>
        <rt-table-column label="文件大小" prop="size"></rt-table-column>
        <rt-table-column label="上传用户" prop="createdby"> </rt-table-column>
        <rt-table-column label="上传时间" prop="createdon"> </rt-table-column>

        <rt-table-column label="操作" align="right">
          <template slot-scope="scope">
            <a class="rt-file-list-href" :href="scope.row.path" :download="scope.row.filename"
              @click="downloadFile(scope.row)">下载</a>
              <!-- approvalstatus!=3可删除或canDelete为true可删除，先判断canDelete，在判断approvalstatus -->
            <a class="rt-file-list-href" v-if="!canDelete?false:approvalstatus!=3" @click="deleteChannelFile(scope.row)">删除</a>
            <a class="rt-file-list-href" v-show="/\.(png|jpe?g|gif|svg)(\?.*)?$/.test(scope.row.filename)"
              @click="previewFile(scope.row)">预览</a>
          </template>
        </rt-table-column>
        <template slot="empty">
          <img style="margin-top: 50px" src="../../../src/assets/imgs/home/no-order.png" alt />
          <p class="nodata-prompt">Sorry！未找到相应结果哦~换个关键词试试！</p>
        </template>
      </rt-table>
    </rt-section>
    <input ref="chooseFile" type="file" value="请点击上传附件" @change="handleFileChange" id="upload" v-show="false">
    <!-- <el-dialog class="middle-dialog" width="640px" title="上传附件" :visible.sync="dialogVisible" :before-close="handleClose">
      <el-upload ref="upload" action="#" :on-success="uploadSuccess" :on-error="uploadError" :on-change="fileChanged"
        class="upload-demo" drag :headers="config" :data="fileData" :name="fileName" :file-list="fileList"
        :before-upload="beforeAvatarUpload" :auto-upload="true">
        <div>
          <img v-if="readFileList.length <= 0" src="../../../src/assets/imgs/up-load.png" alt style="margin-top: 30px" />
          <div class="el-upload__text" :class="{ upload: readFileList.length > 0 }">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
        </div>
      </el-upload>
    </el-dialog>
    <el-dialog title="预览" :visible.sync="previewDialog" :before-close="previewClose">
      <img :src="previewImgUrl" style="width: 100%; min-height: 500px" />
    </el-dialog> -->
  </div>
</template>

<script>
const SIZE = 1 * 1024 * 1024; // 切片大小 1M
const MAXSIZE = 200 * 1024 * 1024; // 切片大小 1M
export default {
  name: "RtFileList",
  props: {
    title: {
      type: String,
      default: "注释",
      //   default: () => {
      //     return "all.annotation";
      //   },
    },
    iconName: {
      type: String,
      default: "注释",
    },
    moduleType: {
      type: String,
      required: true,
    },
    Subject: {
      type: String,
      required: false,
    },
    objectId: {
      type: String,
      required: true,
    },
    canUpload: {
      type: Boolean,
      default: true,
    },
    canDelete: {
      type: Boolean,
      default: true,
    },
    canDownload: {
      type: Boolean,
      default: true,
    },
    canPreview: {
      type: Boolean,
      default: true,
    },
    approvalstatus: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      dataList: [],
      loading: false,
      dialogVisible: false,
      fileUploadUrl: "../api/attachment/upload99",
      fileName: "",
      config: {
        Authorization: "Bearer " + this.$store.state.auth.accessToken,
      },
      fileData: {
        ModuleType: this.moduleType,
        Subject: this.Subject,
        FileId: "",
        FileName: this.fileName,
        ObjectId: this.objectId,
        IsOverwrite: "0",
      },
      fileList: [],
      previewImgUrl: "",
      previewDialog: false,
      readFileList: [],
      container: {
        file: null,
        filename: null,
        size: 0
      },
      chunkPath: [],
      chunkNum: 1,
      successNum: 0,
      isZiping: false, //是否正在压缩
      num: 0, //数据总条数
      ids: [], //选中条数
      ownerid: ''
    };
  },
  computed: {
    process: function () {
      return Math.floor(this.successNum * 100 / this.chunkNum);
    },
    user() {
      return this.$store.state.user;
    }
  },
  watch: {
    objectId(newVal) {
      if (newVal) {
        this.fileData.ObjectId = newVal;
        this.getDataList();
      }
    },
  },
  mounted() {
    if (this.objectId)
      this.getDataList();
  },
  methods: {
    deleteChannelFile(row) {
      //业支是3 可以删   其余只能负责人是自己的。
      let url = "api/DMSCommon/UpdateFile?id=" + row.annotationid
      if (this.approvalstatus == 3) {
        return rt.showErrorToast("已审核单据无法删除附件");
      }
      this.$confirm(this.$t("是否确认删除"), {
        confirmButtonClass: "ConfirmButtonClass",
        cancelButtonClass: "CancelButtonClass",
        type: "warning",
      })
        .then(() => {
          rt.get(url).then(res => {
            rt.showSuccessToast("删除成功")
            this.getDataList();
          }).catch((error) => {
            rt.showErrorToast(error);
          });

        })
        .catch((error) => {
          // this.isSave = false;
          // rt.showErrorToast(error);
          this.$message({
            type: "info",
            message: this.$t("已取消删除"),
          });
        });

    },
    handleSelectionChange(val) {
      console.log('选中数据', val)
      // 列表 check 选择行id
      this.ids = val.map((item) => {
        return item.annotationid;
      });
    },
    //批量下载
    downloadMuiltiple: function () {

      if (this.isZiping) return;
      //1.校验附件数量
      // if (this.num <= 0) {
      //   Xrm.Utility.alertDialog("未查询到附件信息");
      //   return;
      // }
      // console.log(this.annotations);
      // //下载附件
      // let ids = '';
      // this.annotations.forEach(i => {
      //   if (i.checked) {
      //     ids += i.annotationid + ','
      //   }
      // });
      // if (ids[ids.length - 1] == ',') {
      //   ids = ids.slice(0, ids.length - 1);
      // }
      if (!this.ids || !this.ids.length) {
        rt.showErrorToast("请选择要下载的附件")
        return
      }
      this.isZiping = true;
      // rtcrm.invokeHiddenApiAsync("new_file", "FileHelper/DownloadFiles", {
      //   entityId: this.entityid,
      //   entityName: this.entityName,
      //   fileIds: ids
      // }).then(res => {
      //   let url = window.location.origin + '\\annotation\\' + res;
      //   this.downloadFilebyURL(url, '压缩文件.zip');
      //   this.isZiping = false;
      // }).catch(err => {
      //   this.isZiping = false;
      //   Xrm.Utility.alertDialog("下载失败：" + err);
      //   throw new Error(err)
      // })
      // let ids = this.ids.join(",")
      let ids = '';
      this.ids.forEach(i => {
        ids += i + ','
      });
      if (ids[ids.length - 1] == ',') {
        ids = ids.slice(0, ids.length - 1);
      }
      let url = "api/DMSCommon/DownloadFiles?entityId=" + this.objectId + "&entityName=" + this.moduleType + "&fileIds=" + ids;
      let params = {
        entityId: this.objectId,
        entityName: this.moduleType,
        fileIds: ids
      }
      this.loading = true
      rt.get(url, params).then(res => {
        // let u = res.slice(1)
        let u = res.substring(1, res.length - 1)
        let url = window.location.origin + '\\annotation\\' + u;
        // let url = "http://10.88.58.20:8066" + '\\annotation\\' + u;
        this.downloadFilebyURL(url, '压缩文件.zip');
        this.isZiping = false;
      }).catch(err => {
        this.isZiping = false;
        // Xrm.Utility.alertDialog("下载失败：" + err);
        this.loading = false
        rt.showErrorToast("下载失败")
        throw new Error(err)
      })
    },
    downloadFilebyURL: function (filePath, name) {

      this.loading = false
      console.log('filePath', filePath)
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = filePath
      link.setAttribute(
        'download',
        name
      )
      document.body.appendChild(link)
      link.click()
    },
    // 获取上传文件
    handleFileChange(e) {
      //var files = document.getElementById("upload").files;
      const [file] = e.target.files;
      console.log(file)
      if (!file) {
        this.container.file = null;
        return;
      }
      this.pleaseuploadfile = file.name;
      //校验大小
      if (file.size > MAXSIZE) {
        // Xrm.Utility.alertDialog("请上传小于200M附件");
        rt.showErrorToast("请上传小于200M附件")
        this.container.file = null;
        this.pleaseuploadfile = '点击上传附件...'
        return
      }
      //校验文件类型
      var filesuffixList = file.name.split('.');

      let url = "api/DMSCommon/CheckFileType?suffix=" + filesuffixList.pop();

      rt.get(url).then(res => {
        // if (filesuffixList.length <= 1 || !res) {
        //   rt.showErrorToast("该类型文件不允许上传");
        //   this.container.file = null;
        //   return
        // }
        this.container.file = file;
        this.container.filename = file.name;
        this.container.size = file.size;
        this.handleUpload()
      }).catch(err => {
        rt.showErrorToast(err)
      })

    },
    handleUpload() {
      if (this.isUploading == true) {
        rt.showErrorToast('请等待上传中文件上传结束再操作');
        return;
      }
      if (!this.container.file) {
        rt.showErrorToast('请选择文件');
        return;
      }

      if (!this.objectId) {
        rt.showErrorToast("请先保存单据后再上传附件");
        return;
      }

      // this.entityid = entityobj.replace("{", "").replace("}", "");
      // this.ordername = window.parent.Xrm.Page.getAttribute("name") && window.parent.Xrm.Page.getAttribute("name").getValue() || window.parent.Xrm.Page.getAttribute("new_name").getValue(),
      this.entityid = this.ObjectId
      //开始上传 防止重复上传
      this.isUploading = true;
      // 切片生成
      this.isShowProcess = true;
      this.status = "开始上传..."
      this.loading = true
      const fileChunkList = this.createFileChunk(this.container.file);
      let collection = [];
      let collection2 = [];
      let that = this;
      let fileId = this.guid();
      this.chunkNum = fileChunkList.length;
      this.successNum = 0;
      fileChunkList.map((itm, idx) => {

        //转化base64格式
        let p = this.BlobToBase64(itm).then(async (res) => {
          //upload(res)//上传文件
          //上传切片文件
          let fileobj = {
            ChunkId: 10000 + idx,
            Base64Str: res.split(";base64,")[1],
            FileName: that.container.filename,
            FileId: fileId,
            Entity: that.moduleType,
            EntityId: that.objectId,
            Subject: that.Subject,
            NoteText: that.notetext
          };
          //console.log(fileobj);
          let p2 = rt.post("api/DMSCommon/upload", fileobj).then(res => {
            that.chunkPath.push(res);
            that.successNum++;
          }).catch(err => {
            that.status = "[上传失败]" + err
            throw new Error(err)
          })
          console.log(p2);
          collection2.push(p2);

        })
        console.log(p);
        collection.push(p);
      })
      console.log(collection);
      that.status = "开始切片..."
      Promise.all(collection).then(() => {
        that.status = "切片完成正在上传..."
        Promise.all(collection2).then(() => {
          that.status = "上传完毕准备合并..."
          //全部完成
          console.log("done"); //alert("done");
          //合并文件+删除切片
          //文件名 切片路径
          if (that.chunkPath.length > 0) {
            let arr = that.chunkPath[0].split("\\");
            arr.pop();
            arr.pop();
            arr.shift();
            arr.shift();
            let mobj = {
              ChunkPath: arr.join("\\"),
              // EntityName: that.entityName,
              // EntityId: that.entityid,
              EntityName: that.moduleType,
              EntityId: that.objectId,
              FileName: that.container.filename,
              Subject: that.Subject,
              NoteText: "",
              FileSize: that.container.size,
              OrderNo: that.title
            }
            // let uploadfilename = that.container.filename;
            // rtcrm.invokeHiddenApiAsync("new_file", "FileHelper/Merge", {
            //   model: mobj
            // }).then(res => {
            //   that.chunkPath = [];
            //   that.status = uploadfilename + " 上传完成";
            //   that.isUploading = false;
            //   setTimeout(that.reloadData(), 500)
            // });

            console.log('----mobj', mobj)
            rt.post("api/DMSCommon/Merge", mobj).then(res => {
              that.chunkPath = [];
              // that.status = uploadfilename + " 上传完成";
              // that.isUploading = false;
              this.loading = false
              setTimeout(that.getDataList(0), 500)
            }).catch(err => {
              this.loading = false
              rt.showErrorToast(err)
              that.isUploading = false;
            });
          }

        }).catch(err => {
          this.loading = false
          rt.showErrorToast(err)
          that.isUploading = false;
        })

      }).catch((err) => {
        this.loading = false
        // 有失败的情况
        rt.showErrorToast(err)
        that.status = "失败"
        that.isUploading = false;
      });
    },
    //在methods总通过方法计算返回对应class样式
    tabRowClassName({
      row,
      rowIndex
    }) {
      let index = rowIndex + 1;
      if (index % 2 == 0) {
        return "even-row";
      }
    },
    getDataList() {
      this.loading = true;
      // let apiUrl = `/api/attachment?moduleType=${this.moduleType}&objectId=${this.objectId}`;
      // rt.get(apiUrl)
      //   .then((res) => {
      //     this.loading = false;
      //     this.dataList = res;
      //     this.dataList.forEach((d) => {
      //       d.CreatedOn = d.CreatedOn.replace(/T/g, " ").replace(/Z/g, "");
      //     });
      //   })
      //   .catch((error) => {
      //     rt.showErrorToast(error);
      //   });
      // let apiUrl = `/api/attachment?moduleType=${this.moduleType}&objectId=${this.objectId}`;
      let apiUrl = `api/DMSCommon/GetFileList?entityid=` + this.objectId
      rt.get(apiUrl)
        .then((res) => {
          console.log('res', res)
          this.loading = false;
          this.dataList = []
          if (res.getFiles && res.getFiles.length) {
            res.getFiles.forEach(f => {
              var fileitem = {};
              fileitem.annotationid = f["annotationid"];
              fileitem.filename = f["filename"];
              fileitem.checked = false; //声明标志位，表示该列是否被选中，默认为false
              fileitem.delete = false; //声明标志位，用于显示子网格删除按钮，默认为false
              fileitem.createdon = f["createdon"];
              fileitem.mimetype = f["mimetype"];
              fileitem.size = f["size"] + " KB";
              fileitem.createdby = f["createdby"];
              // fileitem.path = window.location.origin + '\\annotation\\' + f["new_filepath"];
              // fileitem.path = 'http://10.88.58.20:8066' + '\\annotation\\' + f["path"];
              fileitem.path = window.location.origin + '\\annotation\\' + f["path"];
              //预览 图片+pdf
              fileitem.preview = false;
              if (f["mimetype"] && (f["mimetype"].toString().indexOf("image/") >= 0 || f["mimetype"].toString().indexOf("/pdf") >= 0)) {
                fileitem.preview = true;
              }
              this.dataList.push(fileitem)
            })
          } else {
            this.dataList = []
          }
          console.log('-=-=-=', this.dataList)
          // this.dataList = res;
          // this.dataList.forEach((d) => {
          //   d.CreatedOn = d.CreatedOn.replace(/T/g, " ").replace(/Z/g, "");
          // });
        })
        .catch((error) => {
          rt.showErrorToast(error);
        });
    },
    // 限制文件大小
    beforeAvatarUpload(file) {
      // const isLt2M = file.size / 1024 / 1024 < 5;
      // if (!isLt2M) {
      //   this.$message.error("上传文件大小不能超过 5MB!");
      // }
      // return isLt2M;
      var isLt2M = true
      if (file.size > MAXSIZE) {
        rt.showErrorToast("请上传小于200M附件");
        isLt2M = false;
      }
      return isLt2M;
    },

    //下载附件
    downloadFile(row) {
      let url = "api/DMSCommon/CreateDownloadLog?id="+row.annotationid;

      this.loading = true
      rt.get(url).then(res => {
        this.loading = false
      }).catch(err => {
        this.loading = false
        rt.showErrorToast("下载失败")
        throw new Error(err)
      })
    },
    previewFile(row) {
      let {
        filename,
        Id
      } = row;

      let isImage = /\.(png|jpe?g|gif|svg)(\?.*)?$/.test(filename);
      if (!isImage) return;
      // this.previewImgUrl =
      //   rt.getBaseUrl() +
      //   "api/attachment/download/" +
      //   this.moduleType +
      //   "/" +
      //   Id;
      if (row.path) {
        window.open(row.path);
      }
      this.previewDialog = true;
    },
    previewClose(done) {
      this.previewImgUrl = "";
      done();
    },
    deleteFile() {
      if (!this.canDelete) return;

      let selectedList = this.$refs.gridTable.selection;
      if (selectedList.length === 0) {
        rt.showErrorToast("请至少选择一个文件");
        return;
      }
      var that = this;
      that
        .$confirm("确定删除？", "警告", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          let baseUrl = "api/attachment/delete/" + this.moduleType + "/";
          let promiseList = selectedList.map((item) => {
            return rt.get(baseUrl + item.Id);
          });
          Promise.all(promiseList)
            .then(() => {
              this.getDataList();
            })
            .catch((error) => {
              rt.showErrorToast(error);
            });
        });
    },
    uploadFile() {
      this.$refs.chooseFile.dispatchEvent(new MouseEvent('click')) //选择文件
      // this.dialogVisible = true;
    },
    S4: function () {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    },
    guid: function () {
      return (this.S4() + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4());
    },
    BlobToBase64(blob) {
      return new Promise(function (resolve) {
        const reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onload = function () {
          resolve(this.result)
        }
      })
    },
    //切片
    createFileChunk(file, size = SIZE) {
      const fileChunkList = [];
      let cur = 0;
      while (cur < file.size) {
        fileChunkList.push(file.slice(cur, cur + size));
        cur += size;
      }
      return fileChunkList;
    },

    uploadSuccess(response, file, fileList) {

      let success = true;
      this.readFileList = fileList;
      fileList.forEach((item) => {
        if (item.status !== "success") {
          success = false;
        }
      });
      if (success) {
        this.$message({
          showClose: true,
          message: "附件上传成功！",
          type: "success",
        });
        this.getDataList();
      }

      // 上传成功
      // if (response.ErrorCode == 0) {
      //   this.$message({
      //     showClose: true,
      //     message: file.name + "附件上传成功！",
      //     type: "success"
      //   });
      // } else {
      //   this.$message({
      //     showClose: true,
      //     message: response.Message,
      //     type: "error"
      //   });
      // }
    },
    uploadError(err, file) {
      // 上传失败
      this.$message({
        showClose: true,
        message: err,
        type: "error",
      });
    },
    handleClose(done) {
      this.$refs.upload.clearFiles();
      done();
    },
  },
};
</script>

<style>
.el-upload {
  width: 100%;
}

.upload-demo {
  position: relative;
}

.upload-demo .el-upload-list__item-name {
  height: 26px;
  color: #143e81 !important;
}

.upload-demo .el-upload-list__item-name [class^="el-icon"] {
  height: initial;
}

a.rt-file-list-href {
  cursor: pointer;
  color: #1890ff;
  text-decoration: none;
  font-size: 15px !important;
}

.upload {
  text-align: left !important;
  margin-left: 22px;
}

.el-upload-list {
  position: absolute;
  top: 38%;
  left: 9%;
  right: 9%;
}

.el-upload-list__item {
  background: #f7f9fc;
  padding: 0 22px;
  color: #143e81 !important;
}

.el-upload-list__item-status-label i {
  margin-top: 6px;
}

.el-upload-list__item .el-icon-upload-success {
  color: #55ceb3;
}
</style>



// WEBPACK FOOTER //
// file-list.vue?0dc77a5d